import { useAppSettings } from '../context/SettingsContext';
import { isStripeConfigured } from '../services/secretConfigured';

/** Stripe ready when secret is in local settings or stored in Secret Manager. */
export function useStripeApi() {
  const { settings, isSecretConfigured } = useAppSettings();
  const ready = isStripeConfigured(settings, isSecretConfigured);
  const localSecretKey = settings.integrations.stripe.secretKey.trim();
  return { settings, isSecretConfigured, ready, localSecretKey };
}
